import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NbDialogRef } from "@nebular/theme";
import * as moment from "moment";
import { Subject } from "rxjs";
import { map, takeUntil } from "rxjs/operators";
import { convertTimestamp } from "../../@core/utils/convertTimestamps.service";
import { Receipt } from "../../models/receipt.model";

import { ReceiptService } from "../../services/receipt.service";

@Component({
  selector: "ngx-dialog-link-receipt",
  templateUrl: "dialog-link-receipt.component.html",
  styleUrls: ["dialog-link-receipt.component.scss"],
})
export class DialogLinkReceiptComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() header: string;
  @Input() shopId?: string;
  @Input() uid?: string;
  @Input() customerId?: string;
  @Input() isClosed: boolean = false;
  @Input() issueDate: Date = new Date();
  receipts?: Receipt[] = [];

  loading = false;
  submitted = false;
  strSearch = "";
  timestamp = 0;

  constructor(
    protected ref: NbDialogRef<DialogLinkReceiptComponent>,
    private receiptService: ReceiptService
  ) {}

  ngOnInit() {
    if (this.customerId) {
      this.getReceiptsByCustomer();
    } else {
      this.getOpenReceipts();
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getReceiptsByCustomer() {
    this.loading = true;
    const fromDate = moment("1800-01-01").startOf("day").toDate();
    const toDate = moment("3000-12-01").endOf("day").toDate();

    this.receiptService
      .getReceiptsByCustomer(this.shopId, this.customerId, fromDate, toDate)
      .snapshotChanges(["added", "removed"])
      .pipe(
        map((changes) =>
          changes.map((c) => ({
            id: c.payload.doc.id,
            ...c.payload.doc.data(),
            issueDate: convertTimestamp(c.payload.doc.data().issueDate),
          }))
        ),
        takeUntil(this.destroy$)
      )
      .subscribe((data) => {
        this.receipts = data;
        this.loading = false;
      });
  }

  getOpenReceipts() {
    this.loading = true;
    this.receiptService
      .getOpenReceipts(this.shopId, this.uid, this.isClosed, this.issueDate)
      .snapshotChanges(["added", "removed"])
      .pipe(
        map((changes) =>
          changes.map((c) => ({
            id: c.payload.doc.id,
            ...c.payload.doc.data(),
            issueDate: convertTimestamp(c.payload.doc.data().issueDate),
          }))
        ),
        takeUntil(this.destroy$)
      )
      .subscribe((data) => {
        this.receipts = data;

        this.loading = false;
      });
  }

  cancel() {
    this.ref.close();
  }

  selected(item) {
    this.submitted = true;
    this.ref.close(item);
  }

  loadContent(value, item) {
    item.isMore = value;
  }
}
